module.exports = {
        srcSet: __webpack_public_path__ + "static/media/HowItWorkSection2-166.59d941b5.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/HowItWorkSection2-166.59d941b5.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/HowItWorkSection2-166.59d941b5.webp",
        toString: function(){return __webpack_public_path__ + "static/media/HowItWorkSection2-166.59d941b5.webp"},
        
        width: 166,
        height: 166
      }